import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, onWheel, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground [&:not(.bg-transparent)]:hover:bg-slate-50 focus:outline-none focus:ring-1 focus:ring-input-focus focus:border-input-focus focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-input-focus focus-visible:border-input-focus disabled:cursor-not-allowed disabled:opacity-50 md:text-sm transition-colors",
          type === "number" && "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 [&::-webkit-outer-spin-button]:m-0",
          className
        )}
        ref={ref}
        onWheel={(e) => {
          if (type === "number" && document.activeElement === e.currentTarget) {
            e.currentTarget.blur();
          }
          onWheel?.(e);
        }}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
